
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.721 18.591h-3.256v-5.063c0-1.207-.021-2.761-1.693-2.761-1.696 0-1.955 1.315-1.955 2.673v5.15H8.561V8.18h3.126v1.422h.044a3.415 3.415 0 011.307-1.264 3.445 3.445 0 011.776-.418c3.3 0 3.908 2.155 3.908 4.96v5.711zM4.888 6.756c-.374 0-.739-.11-1.05-.316a1.864 1.864 0 01-.287-2.887 1.893 1.893 0 012.06-.407c.345.142.64.383.847.691a1.867 1.867 0 01-.847 2.776 1.9 1.9 0 01-.723.143zM6.516 18.59h-3.26V8.18h3.26v10.412zM20.344.001H1.621A1.61 1.61 0 00.482.454 1.587 1.587 0 000 1.574v18.67c.005.423.178.826.482 1.12a1.61 1.61 0 001.139.455h18.723c.426.005.837-.158 1.142-.453.305-.295.48-.699.486-1.122V1.573a1.591 1.591 0 00-.486-1.121A1.613 1.613 0 0020.344 0","fill":"#008CF6"}})])
          )
        }
      }
    